import { types as t, getRoot } from '@invisr/mobx-state-tree'
import AssignmentItem from './assignment'
import crudActions from './crud-actions'
import Auditable from './auditable'
import ref from './reference'
import _get from 'lodash/get'

export const AssignmentVersion = t
  .model('AssignmentVersion', {
    id: t.identifier,
    shortId: t.string,
    name: t.maybeNull(t.string),
    assignment: ref(AssignmentItem, 'assignments')
  })
  .views(self => ({
    get group () {
      return self.assignment.group
    },
    get isCurrent () {
      let root = getRoot(self)
      return (
        _get(root, `currentAssignmentVersions.${self.assignment.group}.${self.assignment.device}`) ===
        self.id
      )
    }
  }))
  .actions(crudActions)

export default t.compose(
  'AssignmentVersion',
  AssignmentVersion,
  Auditable
)
